import { MDCDialog } from '@material/dialog/dist/mdc.dialog';

/**
 * Init MDC Dialogs and their toggles.
 * 
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-dialog
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMDCDialog(dialog) {
	if (dialog) {
		const MDCDialogInst = new MDCDialog(dialog);
		const toggles = document.querySelectorAll(`*[for="${dialog.id}"], *[href="#${dialog.id}"]`);
		if (toggles && (toggles.length > 0)) {
			toggles.forEach((toggle, i) => {
				toggle.addEventListener('click', (e) => {
					e.preventDefault();
					MDCDialogInst.show();
				});
			});
		}
	}
}

export function initMDCDialogs() {
	const dialogs = document.querySelectorAll('.mdc-dialog');
	if (dialogs && (dialogs.length > 0)) {
		dialogs.forEach((dialog, i) => {
			initMDCDialog(dialog);
		});
	}
}